import { Marker } from "react-map-gl/mapbox";

const MapMarker = ({ coordinates, onDrag, draggable, sequence }) => {
  const { latitude, longitude } = coordinates;

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      draggable={draggable}
      onDragEnd={(e) => {
        const { lng, lat } = e.lngLat;
        onDrag?.({ latitude: lat, longitude: lng });
      }}
    >
      <div
        style={{
          width: sequence ? 18 : 12,
          height: sequence ? 18 : 12,
          borderRadius: "50%",
          backgroundColor: "#FFB500",
          boxShadow: "0 0 0 4px #FFF6E0, 0 2px 4px rgba(0, 0, 0, 0.3)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {sequence !== undefined && (
          <span
            style={{
              color: "#FFF6E0",
              fontSize: "0.7rem",
              fontWeight: "bold",
            }}
          >
            {sequence}
          </span>
        )}
      </div>
    </Marker>
  );
};

export default MapMarker;
